window.addEventListener('load', () => {
    document.querySelector('header').classList.add('loaded');

    document.querySelector('body').addEventListener('click', (e) => {
        if (
            e.target == document.querySelector('#block-happiness-local-tasks h2')
        ) {
            if (
                document
                    .querySelector('#block-happiness-local-tasks')
                    .classList.contains('active')
            ) {
                document
                    .querySelector('#block-happiness-local-tasks')
                    .classList.remove('active');
            } else {
                document
                    .querySelector('#block-happiness-local-tasks')
                    .classList.add('active');
            }
        }
    });

    document
        .querySelector('.hamburger-menu-icon')
        .addEventListener('click', (e) => {
            if (document.querySelector('header').classList.contains('opened')) {
                document.querySelector('header').classList.remove('opened');
                document.querySelector('html').classList.remove('disable-scroll');

                //window.scrollTo({ top: 0 });

            } else {
                document.querySelector('header').classList.add('opened');
                document.querySelector('html').classList.add('disable-scroll');

                //window.scrollTo({ top: 0 });

                const openMobileMenu = document.querySelector('.sticky-menu-container');

                //openMobileMenu.style.position = 'inherit';
            }
        });
});


function HeaderStickyShow() {
    const siteheader = document.querySelector('.main-header');

    //console.log(siteheader.offsetHeight);
    //console.log(window.scrollY);

    if (document.getElementById("toolbar-administration")) {
        if (window.scrollY > 45) {
            siteheader.classList.add('sticky');
            document.querySelector('body').classList.add('sticky-header');
    
            if (document.getElementById("toolbar-administration")) {
                document.querySelector(".sticky-header .sticky-menu-container").style.top = "80px";
            }
        } else {
            siteheader.classList.remove('sticky');
            document.querySelector('body').classList.remove('sticky-header');
        }
    } else {
        if (window.scrollY > 45) {
            siteheader.classList.add('sticky');
            document.querySelector('body').classList.add('sticky-header');
    
        } else {
            siteheader.classList.remove('sticky');
            document.querySelector('body').classList.remove('sticky-header');
        }
    }

}

window.addEventListener('scroll', () => {
    HeaderStickyShow();
});

window.onload = function (e) {
    HeaderStickyShow();
};
